<div (infiniteReached)="loadMore()"
     *ngIf="loading || requests?.length"
     [distance]="size"
     [enabled]="requests.length < total || loading"
     class="workflows-list workflows-list--no-border"
     gp-infinite-scroll
     test-id="requests-in-progress">
  <div *ngFor="let request of requests" class="workflow-cell read">
    <div class="col-md-10 col-xs-9 workflow-cell--description">
          <span class="workflow-cell--title">
            {{ request?.translationKeys.title | translate | translateAndFormatVariables: request.variables: (trigger$|async) }}
          </span>
      <div class="workflow-cell--subtitle">
        {{ request?.translationKeys.subtitle | translate | translateAndFormatVariables: request.variables: (trigger$|async) }}
      </div>
    </div>
    <div class="col-xs-3 workflow-cell--extra">
      <div>{{ 'WORKFLOWS.started_on' | translate }} {{ request.startTime | gpDate: {} : (trigger$|async) }}</div>
      <button (click)="onCancelRequest(request)" *ngIf="request?.cancellable" class="btn btn-sm b-light"
              type="button">
        <span class="fa fa-light fa-ban"></span>
        {{ 'WORKFLOWS.cancel' | translate }}
      </button>
    </div>
  </div>
  <div *ngIf="loading" class="p-x-sm">
    <p>
      <skeleton-block width="100%" height="100px" [effect]="'wave'" borderRadius="4"></skeleton-block>
    </p>
    <p>
      <skeleton-block width="100%" height="100px" [effect]="'wave'" borderRadius="4"></skeleton-block>
    </p>
    <p>
      <skeleton-block width="100%" height="100px" [effect]="'wave'" borderRadius="4"></skeleton-block>
    </p>
  </div>
</div>

<gp-illustrated-message *ngIf="!loading && !requests.length" [text]="'WORKFLOWS.no_request'"
                        [width]="'60%'"></gp-illustrated-message>
